import type { ReactNode } from 'react';

export const symbol_explore_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-64 19-125t57-113l-74-74q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l710 710q9 9 9 21t-9 21q-9 9-21.5 9T792-83l-74-73q-52 38-113 57T480-80Zm73-473ZM408-408ZM275-824q47-28 99-42t106-14q80 0 153 30t130 87q57 57 87 130t30 153q0 54-13.5 105T827-277q-6 11-18 13.5t-23-4.5q-11-7-13-19.5t4-23.5q21-39 32-81.5t11-87.5q0-142-99-241t-241-99q-45 0-88 11t-82 33q-11 6-22.5 4T268-784q-8-10-6-22t13-18Zm301 354L470-576q-6-6-4-14.5t10-10.5l153-47q9-3 15.5 3.5T648-629l-47 153q-2 8-10.5 10t-14.5-4Zm-96 330q55 0 104-15.5t91-43.5L508-366l-178 55q-9 3-15.5-3.5T311-330l55-178-167-167q-28 42-43.5 91T140-480q0 145 97.5 242.5T480-140Z"
		/>
	</svg>
);
